module.exports = __webpack_public_path__ + "img/arrow-left.52053a1b.svg";